import { render, staticRenderFns } from "./traceabilityQR.vue?vue&type=template&id=7233e8c2&scoped=true&"
import script from "./traceabilityQR.vue?vue&type=script&lang=js&"
export * from "./traceabilityQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7233e8c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
